import { ButtonsOptions, HorizontalAlignmentOptions, TextStyleOptions } from '@df/ui/atomic/atomic-options';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { BASIC_COMPONENT_FIELDS, CMS_COMPONENT_CWV_CONFIG } from '../../../../config/component.config';

export default <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: 'full-width-banner',
    name: 'Full Width Banner',
    image: 'assets/images/cms/full-width-banner.png',
    tags: ['Homepage', 'Banner', 'Video'],
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'general',
            title: 'General'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'link',
            title: 'Link',
            default: '/'
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'image-video-section',
            title: 'Image/video'
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'image',
            title: 'Image',
            description: 'If both image and video are set then image will be use as a placeholder till video is loaded',
            default: ''
        },
        {
            key: 'video_id',
            type: NICmsContentField.EFieldType.text,
            title: 'ID or URL',
            description: 'Video ID or URL, e.g. https://vimeo.com/442627127'
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'blocks-positioning',
            title: 'Text box position'
        },
        <NICmsContentField.INumberField>{
            key: 'left_position',
            type: NICmsContentField.EFieldType.number,
            title: 'Distance from the left',
            min: 0,
            max: 100,
            step: 1,
            default: 0
        },
        <NICmsContentField.INumberField>{
            key: 'top_position',
            type: NICmsContentField.EFieldType.number,
            title: 'Distance from the top',
            min: 0,
            max: 100,
            step: 1,
            default: 50
        },
        <NICmsContentField.IChoiceField>{
            key: 'text_align',
            type: NICmsContentField.EFieldType.choice,
            title: 'Text Alignment',
            options: HorizontalAlignmentOptions,
            default: 'left'
        },
        {
            type: NICmsContentField.EFieldType.label,
            key: 'text-box-content',
            title: 'Text box content'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'heading',
            title: 'Heading',
            default: 'dolor sit amet consectetur'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title',
            default: 'Lorem ipsum'
        },
        <NICmsContentField.IField>{
            key: 'text_color',
            type: NICmsContentField.EFieldType.colorPicker,
            title: 'Text Color'
        },
        <NICmsContentField.IChoiceField>{
            key: 'title_style',
            type: NICmsContentField.EFieldType.choice,
            title: 'Title Style',
            options: TextStyleOptions
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'cta_text',
            title: 'Button Label',
            default: 'Find out more'
        },
        <NICmsContentField.IChoiceField>{
            key: 'cta_style',
            type: NICmsContentField.EFieldType.choice,
            title: 'Button Style',
            options: ButtonsOptions
        },
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.toggle,
            key: 'text_box_below',
            title: 'Text box below',
            default: false
        },
        ...BASIC_COMPONENT_FIELDS,
        ...CMS_COMPONENT_CWV_CONFIG
    ]
};
